import { render, staticRenderFns } from "./ViewMoreBtn.vue?vue&type=template&id=f5ca2bf4&scoped=true&"
import script from "./ViewMoreBtn.vue?vue&type=script&lang=js&"
export * from "./ViewMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./ViewMoreBtn.vue?vue&type=style&index=0&id=f5ca2bf4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ca2bf4",
  null
  
)

export default component.exports